import type { Types } from '@common/models';
import { ArticleType } from '../components/molecules/Article';

/**
 * Convert Rank type to ArticleType
 * Rank doesn't have serverMetas, so we create default values from ChDetail
 */
export const convertRankToArticle = (rank: Types['Rank'], meta?: Types['ChDetail']): ArticleType => {
  const linkUrl =
    meta?.canonical ||
    meta?.resolvedUrl ||
    (rank.connection.startsWith('/') ? rank.connection : `/${rank.connection}`);

  // Build serverMetas from meta or use defaults
  const serverMetas = {
    'og:image': meta?.og?.image || '',
    'og:description': meta?.description || rank.content || '',
    'twitter:site': meta?.twitter?.site || '',
    'fb:page_id': meta?.og?.['fb:page_id'] || '',
    'al:ios:app_store_id': meta?.apple?.['app_store_id'] || '',
    'al:android:package': meta?.google?.['package'] || '',
  };

  return {
    ch: rank.connection,
    title: meta?.title || ('title' in rank ? String(rank.title) : '') || rank.connection.replace(/^\/([^/]+).*$/, '$1'),
    favicon: meta?.favicon || rank.favicon || '',
    updateTime: rank.updateTime,
    liveCnt: rank.liveCnt,
    serverMetas,
    linkUrl,
  };
};

export const convertRanksToArticles = (
  ranks: Types['Rank'][],
  metaMap?: Map<string, Types['ChDetail']>
): ArticleType[] => {
  return ranks.map((rank) => {
    const meta = metaMap?.get(rank.connection);
    return convertRankToArticle(rank, meta);
  });
};
